<mh-profile-preview
  *ngIf="talent"
  [talent]="talent"
  [trustedView]="trustedView"
  [cvList]="cvList"
  [fileList]="fileList"
  [references]="references"
  [avatarUrl]="avatarUrl"
></mh-profile-preview>
